import React from 'react';
import styled, { css } from 'styled-components';

const ItemWrapper = styled.div`
  margin-bottom: 12px;
`;

const Label = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.gray};
  margin-bottom: 4px;
  font-weight: 500;
`;

const Value = styled.div`
  font-weight: 600;
  padding: 8px 12px;
  background: ${({ theme }) => theme.colors.light};
  border-radius: ${({ theme }) => theme.radii.sm};
  display: inline-block;
  font-size: 14px;
  width: 100%;
  word-break: break-word;

  ${({ status, theme }) => {
    switch (status) {
      case 'highlight':
        return css`
          background-color: rgba(0, 206, 201, 0.1);
          border-left: 3px solid ${theme.colors.accent};
        `;
      case 'warning':
        return css`
          background-color: rgba(253, 203, 110, 0.1);
          border-left: 3px solid ${theme.colors.warning};
        `;
      case 'danger':
        return css`
          background-color: rgba(214, 48, 49, 0.1);
          border-left: 3px solid ${theme.colors.danger};
        `;
      default:
        return;
    }
  }}
`;

const InfoItem = ({ label, value, status = 'default' }) => {
  return (
    <ItemWrapper>
      <Label>{label}</Label>
      <Value status={status}>{value}</Value>
    </ItemWrapper>
  );
};

export default InfoItem;